export default "__VITE_ASSET__Drr__RxU__"